import React from "react";
import { useBrowserOnly } from "app/main/hooks";
import { Autosuggests } from "./Autosuggests";

// Will be loaded by the SearchbarContainer, which also adds dynamics
import "./style.inline.scss";
import "./style.scss";
import { useAutofocus, useAutosuggest } from "app/frame/Searchbar/hooks";

export interface Suggest {
    Suggests: { suggest: [string, string, string] }[];
}

const MobileButton = () => (
    <a className="mobileButton" title="Suchen" href="https://suche.t-online.de">
        <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 64 64">
            <path d="M37,7a20,20,0,0,1,0,40,19.46,19.46,0,0,1-11.6-3.82h-.12a18.57,18.57,0,0,1-4.54-4.47A20,20,0,0,1,37,7m0-3A23,23,0,0,0,18.3,40.4a21.81,21.81,0,0,0,5.3,5.2A22.41,22.41,0,0,0,37,50,23,23,0,0,0,37,4ZM17.37,42.41,4.9,54.87A3,3,0,1,0,9,59.26l.15-.15,12.5-12.49A23.88,23.88,0,0,1,17.37,42.41Z" />
        </svg>
    </a>
);

export const Searchbar = () => {
    const inputRef = useAutofocus();
    const areWeInBrowser = useBrowserOnly();
    const [currentValue, setCurrentValue] = React.useState("");
    const [hasFocus, setHasFocus] = React.useState(false);
    const suggestions = useAutosuggest(currentValue);

    const handleChange = (e: { target: { value: React.SetStateAction<string> } }) => {
        setCurrentValue(e.target.value);
    };

    return (
        <form
            id="searchbar"
            className="searchbar"
            action="https://suche.t-online.de/fast-cgi/tsc"
            target="_blank"
            method="get"
        >
            <MobileButton />
            <div className="formWrapper">
                <input
                    ref={inputRef}
                    placeholder={areWeInBrowser ? "" : "Suchbegriff eingeben"}
                    className={`search${areWeInBrowser ? " fancyPlaceholder" : ""}${currentValue ? " filled" : ""}`}
                    type="search"
                    title="Suchanfrage eingeben"
                    name="q"
                    autoComplete="off"
                    value={currentValue}
                    onChange={handleChange}
                    onFocus={() => setHasFocus(true)}
                    onBlur={() => setTimeout(() => setHasFocus(false), 100)}
                />
                <button
                    type="submit"
                    className="button"
                    value="Suchen"
                    data-ga-label="Suchanfrage abschicken"
                    data-ga-action="click"
                    data-ga-category={currentValue}
                >
                    Suchen
                </button>
                <Autosuggests suggests={suggestions} showList={hasFocus} />
            </div>
        </form>
    );
};
